import { useRef, createContext, useContext, useCallback, useSyncExternalStore } from 'react';
import { combineReducers } from 'redux';
import { sectionSettingsSlice } from '../slice/sectionSettingsSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const reducer = combineReducers({
  sectionSettings: sectionSettingsSlice.reducer
});
function useStoreData() {
  const store = useRef({
    sectionSettings: sectionSettingsSlice.getInitialState()
  });
  const get = useCallback(() => store.current, []);
  const subscribers = useRef(new Set());
  const dispatch = useCallback(action => {
    if (typeof action === 'function') {
      // Handle thunks
      return action(dispatch, get, undefined);
    }
    store.current = reducer(store.current, action);
    subscribers.current.forEach(callback => callback());
    return undefined;
  }, [get]);
  const subscribe = useCallback(callback => {
    subscribers.current.add(callback);
    return () => subscribers.current.delete(callback);
  }, []);
  return {
    get,
    dispatch,
    subscribe
  };
}
const StoreContext = /*#__PURE__*/createContext(null);
export function FastContext({
  children
}) {
  return /*#__PURE__*/_jsx(StoreContext.Provider, {
    value: useStoreData(),
    children: children
  });
}
export function useFastStore(selector) {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useFastStore must be inside FastStore');
  }
  const state = useSyncExternalStore(store.subscribe, () => selector(store.get()));
  return state;
}
export function useFastDispatch() {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('Store not found');
  }
  return store.dispatch;
}